import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-gray-600 tracking-wider uppercase">
              MedicinPRO
            </h3>
            <p className="mt-4 text-base text-gray-500">
              Encuentra los mejores especialistas médicos y profesionales de la salud en tu ciudad.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-600 tracking-wider uppercase">
              Ciudades
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <a href="/baja-california/ginecologos-en-tijuana" className="text-base text-gray-500 hover:text-gray-900">
                  Tijuana
                </a>
              </li>
              <li>
                <a href="/aguascalientes/ginecologos-en-aguascalientes" className="text-base text-gray-500 hover:text-gray-900">
                  Aguascalientes
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-600 tracking-wider uppercase">
              Legal
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <a href="/privacidad" className="text-base text-gray-500 hover:text-gray-900">
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a href="/terminos" className="text-base text-gray-500 hover:text-gray-900">
                  Términos y Condiciones
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-600 tracking-wider uppercase">
              Para Pacientes
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/especialidades-medicas" className="text-base text-gray-500 hover:text-gray-900">
                  Especialidades Médicas
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 